import { ZT_ROOT_ADDRESS } from '@src/constants/urls';
import BusinessServiceFactory from '../business-service-factory';
import UnmountError from '@src/error/UnmountError';
import zt from './zt';
import ServiceResponseError from '@src/error/ServiceResponseError';

export default class ZtServiceFactory extends BusinessServiceFactory {
  /**
   * 获取默认实例方法, 用于非 component 中使用等情况
   * @type {import('@src/services/zt/services.d.ts').IGeneratedServices}
   */
  static getDefaultInstance() {
    if (!ZtServiceFactory._defaultServiceInstance) {
      ZtServiceFactory._defaultServiceInstance = new ZtServiceFactory().createService();
    }
    // noinspection JSValidateTypes
    return ZtServiceFactory._defaultServiceInstance;
  }

  constructor({ checkIfComponentUnmount } = {}) {
    super({
      /**
       * 队列映射
       * 详细请参考: https://gitlab.xsjcs.cn/xfe/xfe-iframe-application/blob/request-queue/parent/README.md
       * @type {{'jx3/ticket190728/create_order': string}}
       */
      queueMap: {
        /* 'jx3/ticket190728/create_order': 'jx3master' */
      },
      /**
       * 缓存时间, 默认: 100ms
       */
      optimizeUsingCache: 100,

      /**
       * 请求是否携带 utm_source 字段名,
       * 如果设置了字符串, 则将自动上报该字段
       * 如果设置 undefined 或 null 或 false 或 '',则请求时候将不携带 utm_source
       */
      requestWithUtmSourceFieldName: '' /*'utm_source'*/
    });
    this.handleCheckIfComponentUnmount(checkIfComponentUnmount);
  }

  /**
   * 处理检查组件是否被卸载
   * @private
   */
  handleCheckIfComponentUnmount(checkIfComponentUnmount) {
    if (!checkIfComponentUnmount) {
      return;
    }
    const action = () => {
      if (checkIfComponentUnmount() === true) {
        throw new UnmountError();
      }
    };
    this.beforeRequests.push(action);
    this.afterRequestSuccessList.push(action);
    this.afterRequestErrorList.push(action);
  }

  /**
   * 创建服务
   * @type {import('@src/services/zt/services.d.ts').IGeneratedServices}
   */
  createService() {
    return zt({ jsonp: ::this.request }, response => Promise.reject(new ServiceResponseError(response)), ZT_ROOT_ADDRESS);
  }
}
